import mutations from './selectLaboratoryTypesDialog.mutations'
import actions from './selectLaboratoryTypesDialog.actions'
import getters from './selectLaboratoryTypesDialog.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
